import { render, staticRenderFns } from "./RowSectionForm.vue?vue&type=template&id=8b4eb53a&scoped=true&"
import script from "./RowSectionForm.vue?vue&type=script&lang=js&"
export * from "./RowSectionForm.vue?vue&type=script&lang=js&"
import style0 from "./RowSectionForm.vue?vue&type=style&index=0&id=8b4eb53a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4eb53a",
  null
  
)

export default component.exports